import { createContext, useContext, ReactNode } from 'react';
import { TeamMember } from '@dynamika-shared/types/teamMember';
import {
  OnSortColumnType,
  Pagination,
} from '@dynamika-shared/ui/Table/Table.types';
import { TeamMembersControlSchemaType } from '../../uiControlSchemaByStatus/ControlTypes';
import { OrganizationType } from '@dynamika-shared/types/inventory';

export type TeamMembersContextType = {
  teamMemberData: TeamMember[];
  totalItems: number;
  loading: boolean;
  sortState: string | undefined;
  uiControlSchema: TeamMembersControlSchemaType;
  institutions: OrganizationType[];
  pagination: Pagination;
  onSort: OnSortColumnType;
  onClick: (option: 'edit' | 'suspend' | 'delete', member: TeamMember) => void;
};

const TeamMembersContext = createContext<TeamMembersContextType | undefined>(
  undefined
);

const TeamMembersProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: TeamMembersContextType;
}) => {
  return (
    <TeamMembersContext.Provider value={value}>
      {children}
    </TeamMembersContext.Provider>
  );
};

const useTeamMembers = () => {
  const context = useContext(TeamMembersContext);
  if (!context) {
    throw new Error('useTeamMembers must be used within a TeamMembersProvider');
  }
  return context;
};
// eslint-disable-next-line react-refresh/only-export-components
export { useTeamMembers, TeamMembersProvider };
